module.exports = __webpack_public_path__ + "static/media/trait-icons-assertiveness.05f2016f.svg";